import type { IgnorableFn } from '~/composables/datadog'

export const DATADOG_IGNORABLE: IgnorableFn[] = [
  (_, message) => message.includes('zoid destroyed all components'),
  (_, message) => /csp_violation/i.test(message),
  (_, message) => /evaluating 'a\.L'/i.test(message),
  (_, message) => /refused to/i.test(message),
]
